import { type PropsWithChildren } from "react";

export const Header = ({ children }: Readonly<PropsWithChildren>) => (
  <div data-testid="circle-ai-shell-dock-header" className="shrink-0">
    {children}
  </div>
);

Header.displayName = "CircleAIAppShell.Layout.Dock.Header";
